import { ROUTES } from './routes'

/**
 * F-109: the forms paths. `/f/{publicToken}` is the public link (full screen,
 * login optional, the form community's colors, no analytics); `/_/forms/{id}`
 * and `/_/forms/{id}/submissions/{submissionId}` are the e-mail links.
 */
const segmentsAfter = (path: string, prefix: string): string[] =>
  path.split(/[?#]/)[0].slice(prefix.length).split('/').map((s) => decodeURIComponent(s || '').trim())

export const isPublicFormPath = (path: string): boolean => path.startsWith(ROUTES.publicForm)
export const isFormLinkPath = (path: string): boolean => path.startsWith(ROUTES.form)

export const publicFormTokenFrom = (path: string): string => segmentsAfter(path, ROUTES.publicForm)[0] || ''

/** `{ formId, submissionId }` out of `/_/forms/{id}[/submissions/{sid}]`. */
export const formLinkFrom = (path: string): { formId: string; submissionId: string | null } => {
  const [formId = '', kind, submissionId] = segmentsAfter(path, ROUTES.form)
  return { formId, submissionId: kind === 'submissions' && submissionId ? submissionId : null }
}
